import { render, staticRenderFns } from "./ModalListDetails.vue?vue&type=template&id=9c1793e6&"
import script from "./ModalListDetails.vue?vue&type=script&lang=js&"
export * from "./ModalListDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalListDetails.vue?vue&type=style&index=0&id=9c1793e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports